'use strict';
//Utilities
var _ = require('lodash');
var Constants = require('../../constants/YourDetailsConstants');
var ApplicationConstants = require('../../constants/ApplicationConstants');
var ProductIds = ApplicationConstants.ProductIds;
var Values = Constants.Values;
var ClassNames = require('classnames');
var ContentService = require('../../services/ContentService');
//Action
var Action = require('../../actions/YourDetailsActions');
var ApplicationActions = require('../../actions/ApplicationActions');
//React/Components
var React = require('react');
var RadioInput = require('../Common/RadioInput.jsx');
var InlineMessage = require('../Common/InlineMessage.jsx');
var TextInput = require('../Common/TextInput.jsx');
var BeneficiaryRelationship = require('../BeneficiaryDetails/BeneficiaryRelationshipInfo.jsx');
var BeneficiaryConstants = require('../../constants/BeneficiaryDetailsConstant.js');

var PersonalInfo = React.createClass({
    getDefaultProps: function () {
        return {
            index: '',
            section: '',
            errorList: []
        };
    },
    getInitialState: function() {
        return {
            data: this.props.data
        };
    },
    componentWillReceiveProps: function(nextProps) {
        this.setState({data: nextProps.data});
    },
    getTitleListByGender: function() {
        if (this.props.data.gender == Values.GENDER_MALE) {
            return this.props.titleList.m;
        }
        else if (this.props.data.gender == Values.GENDER_FEMALE) {
            return this.props.titleList.f;
        }
        else {
            return this.props.titleList.default;
        }
    },
    updateYourDetailsData: function (event) {
        if (this.props.section === BeneficiaryConstants.BENEFICARY) {
            this.props.onChange(event);
        } else {
            Action.updateYourDetailsData(event.target.model, event.target.id, event.target.value, this.props.index);
            if (event.target.model === 'dateOfBirth') {
                // for Super & Pension products only will send information to funding your x and RIP
                ApplicationActions.sendYourDetailsDob(event.currentTarget.value);
            }
        }
    },
    render: function () {
        var ydContent = ContentService.getContent().yourDetails;
        
        var fullNameError = [];
        var givenNameError = _.filter(this.props.errorList, { id: this.props.section + 'givenName' + this.props.index });
        var lastNameError = _.filter(this.props.errorList, { id: this.props.section + 'lastName' + this.props.index });      
        fullNameError = fullNameError.concat(givenNameError, lastNameError);

        var showBeneficiaryRelationship = this.props.section === BeneficiaryConstants.BENEFICARY;

        var inlineError = function (data, index) {
            return (<InlineMessage key={index} id={'inline-message-fullname-' + index} isHidden={false} type={data.type} message={data.message} />);
        };

        // TODO: There is a mismatch in type not handled correctly now: the title list returned from product Api is having id in int, 
        // the title id we saved for investor in an application is in string type.
        // RadioInput is just now updated to use relaxed comparison to make sure the title list will be expanded on retrieval if
        // the selected title is hidden. We should have updated the title list to use consistent data type but it is too closed to release 1
        // now and the correct fix is not applied.
        return (
            <div>
                <RadioInput id={this.props.section + 'gender' + this.props.index}
                            data={Constants.GenderRadioData}
                            value={this.state.data.gender}
                            label="Gender"
                            onChange={this.updateYourDetailsData}
                            model="gender"
                            errorList={this.props.errorList} 
                            disabled={this.state.data.genderReadonly} />
                <RadioInput id={this.props.section + 'title' + this.props.index}
                            data={this.getTitleListByGender()}
                            value={this.state.data.title}
                            label="Title"
                            onChange={this.updateYourDetailsData}
                            model="title"
                            errorList={this.props.errorList}
                            disabled={this.state.data.titleReadonly} />
                <div className="form-section">
                    <div className="form-label-section">
                        <label htmlFor="full-name">Full name</label>
                    </div>
                    {this.props.givenNameLabel ?
                    <div className="form-label-section form-inline row">
                        <label htmlFor="full-name" className="col-md-4">{this.props.givenNameLabel}</label>
                        <label htmlFor="last-name" className="col-md-2 hidden-xs beneficiary-surname">{this.props.surnameLabel}</label>
                    </div>
                    :null}
                    <p className={ClassNames('hidden-xs', {hidden: this.props.isFullNameMessageHidden})}>{ydContent.fullNameCopy}</p>
                    <div className="form-inline helper-tab">
                        
                        <TextInput id={this.props.section + 'givenName' + this.props.index}
                                   value={this.state.data.givenName}
                                   placeholder="Given name(s)"
                                   hasWarning={givenNameError.length}
                                   className="form-text full-name"
                                   model="givenName"
                                   onBlur={this.updateYourDetailsData}
                                   isDisabled={this.state.data.givenNameReadonly} />
                        <TextInput id={this.props.section + 'lastName' + this.props.index}
                                   value={this.state.data.lastName}
                                   placeholder={this.props.surnameLabel || 'Last name'}
                                   hasWarning={lastNameError.length}
                                   className="form-text"
                                   model="lastName"
                                   onBlur={this.updateYourDetailsData}
                                   isDisabled={this.state.data.lastNameReadonly} />
                    </div>
                        {(fullNameError).map(inlineError)}
                    </div>

                {showBeneficiaryRelationship ?
                            <BeneficiaryRelationship data={this.state.data}
                                                     onChange={this.updateYourDetailsData}
                                                     errorList={this.props.errorList} />
                : null }

                 <TextInput id={this.props.section + 'dateOfBirth' + this.props.index}
                            label="Date of birth"
                            value={this.state.data.dateOfBirth}
                            placeholder={ApplicationConstants.DateFormat}
                            className="form-number-input"
                            onBlur={this.updateYourDetailsData}
                            model="dateOfBirth"
                            contextualMessage={(this.props.age >= 0 && this.props.age < 16) ? ydContent[ProductIds.SUPER].ageInvalidError : undefined}
                            errorList={this.props.errorList}
                            isDisabled={this.state.data.dateOfBirthReadonly}
                            maxLength={10} />
            </div>
        );
    }
});

module.exports = PersonalInfo;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/PersonalInfo.jsx